import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F2C62DAD-9011-4495-B542-87407FFB7EA1
 * name ladder
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ladder.svg
 * tags
 * - Hardware / Tools 
 */
export const LadderIcon = createSvgIcon(<><path d="M14 1V3H10V1H8V22H10V20H14V22H16V1H14M14 5V8H10V5H14M14 10V13H10V10H14M10 18V15H14V18H10Z" /></>, 'LadderIcon');
export default LadderIcon